import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const HorseShoe = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <circle className="cls-1" fill="none" cx="6.75" cy="18.25" r=".5" />
      <circle className="cls-1" fill="none" cx="6.25" cy="8" r=".5" />
      <circle className="cls-1" fill="none" cx="5" cy="13" r=".5" />
      <circle className="cls-1" fill="none" cx="11.75" cy="21" r=".5" />
      <circle className="cls-1" fill="none" cx="17" cy="18.25" r=".5" />
      <circle className="cls-1" fill="none" cx="17.5" cy="8" r=".5" />
      <circle className="cls-1" fill="none" cx="18.75" cy="13" r=".5" />
      <path d="M20 11.25l-.06-.25c0-.15-.11-.37-.19-.64A22 22 0 0017.5 5.5a3.6 3.6 0 00-.5-.75h.75a1 1 0 001-1v-1a1 1 0 00-1-1h-2.5a1 1 0 00-1 1v1.5a2.36 2.36 0 00.12.69c.07.18.13.31.13.31 3 5.25 2.75 8 2.75 8 0 3.27-2.26 5.92-5.37 6s-5.38-2.72-5.38-6c0 0-.25-2.75 2.75-8 0 0 .06-.13.13-.31a2.36 2.36 0 00.12-.69v-1.5a1 1 0 00-1-1H6a1 1 0 00-1 1v1a1 1 0 001 1h.75a3.6 3.6 0 00-.5.75A22 22 0 004 10.39c-.08.27-.15.49-.19.64l-.06.22a8.75 8.75 0 00-.26 2.13 8.7 8.7 0 008.25 8.86H12a8.7 8.7 0 008.25-8.86 8.75 8.75 0 00-.25-2.13zM5 13.5a.5.5 0 11.5-.5.5.5 0 01-.5.5zM5.75 8a.5.5 0 11.5.5.5.5 0 01-.5-.5zm1 10.75a.5.5 0 11.5-.5.5.5 0 01-.5.5zm5 2.75a.5.5 0 11.5-.5.5.5 0 01-.5.5zM17 18.75a.5.5 0 11.5-.5.5.5 0 01-.5.5zm.5-10.25A.5.5 0 1118 8a.5.5 0 01-.5.5zm1.25 5a.5.5 0 11.5-.5.5.5 0 01-.5.5z" />
    </SvgIcon>
  );
};

export default HorseShoe;
